<nav
  class="aos-side-menu"
  [class.aos-side-menu_expanded]="expanded"
  [class.aos-side-menu_collapsed]="!expanded"
>
  <div class="aos-side-menu__header">
    <span class="aos-side-menu__logo">
      <img
        ngSrc="./assets/aclara-logo.svg"
        width="32"
        height="32"
        alt="aclara-logo"
        priority
      />
      <img
        class="aos-side-menu__logo-text"
        ngSrc="./assets/aclara-logo-text.svg"
        width="135"
        height="32"
        alt="aclara-logo"
        priority
      />
    </span>
    @if ((hasBreakpointL$ | async) === false) {
      <ui-icon
        class="aos-side-menu__collapse-button"
        [color]="collapseButtonIconColor"
        [name]="collapseButtonIconName"
        [size]="expanded ? collapseButtonExpandedIconSize : collapseButtonCollapsedIconSize"
        (click)="toggleClicked.emit()"
      />
    }
  </div>
  <div class="aos-side-menu__scrollable-container">
    @if (expanded) {
      <aos-side-menu-expanded [menuItems]="(menuItems$ | async)!"> </aos-side-menu-expanded>
    } @else {
      <aos-side-menu-collapsed [menuItems]="(menuItems$ | async)!"> </aos-side-menu-collapsed>
    }
  </div>
</nav>
